import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  getUniversityList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/art/oldPlan/findUniversityQueryList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  save({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/art/oldPlan/save`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSpecialityList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/art/oldPlan/findProfessionList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSchemeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      try {
        axios({
          method: "post",
          url: "/art/oldPlan/findSchemeList",
          data: params
        }).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      } catch (e) {
        console.log(e);
      }
    });
  },
  getSchemeDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/finalPlan/findSchemeUniversity`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  findBasicConfigData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/oldPlan/findBasicConfigData`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSchemeDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/oldPlan/findSchemeUniversity`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getDictionary({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/fwxtdictionary/findAllItemByTypeCode",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  saveOrUpdateField({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/configPlanField/saveOrUpdateField`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  selectInitialSchemeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/art/oldPlan/findSchemeList`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getSchemeDetailForNewPlanByLastStep({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/art/oldPlan/selectProgramInfoLast`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  exportScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/art/oldPlan/exportScheme",
        data: params,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  recommendScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/report/finalPlan/updateRecommendStatus`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

  // 保存艺考方案可选择字段
  saveArtOrUpdateField({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/artConfigPlanField/saveOrUpdateField`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },

    // 获取专业类别
    getSpecialityTypes({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios.get(`/dictionary/findAllItemByTypeCode`, {params}).then(response => {
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 推荐方案
    recommendScheme({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/art/oldPlan/updateRecommendStatus`, { params })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

};
